import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-search\"><path d=\"M10.075 1c5.005 0 9.077 4.072 9.077 9.076 0 2.285-.855 4.37-2.254 5.967l5.925 5.926a.604.604 0 1 1-.855.854l-5.925-5.925a9.03 9.03 0 0 1-5.968 2.253C5.071 19.151 1 15.08 1 10.076S5.071 1 10.075 1ZM10 18c4.41 0 8-3.59 8-8s-3.59-8-8.001-8C5.589 2 2 5.59 2 10s3.59 8 7.999 8Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol